import BTInputField from "@common-components/bt-input-field/bt-input-field";
import RowStack from "@common-components/common/row-stack/RowStack";
import { CheckBoxOutlined as CheckBoxIcon } from '@mui/icons-material';
import { Checkbox, Stack } from "@mui/material";
import classes from "../bt-chatbot.module.scss";
import { modalTextStyle } from "./bt-chatbot-modal";
import { onChangeParams } from "./bot-settings";
import { useTranslation } from "react-i18next";
import { namespace } from "@common/config/constants";

type Props = {
    isChatbotTimer: boolean;
    chatbotTimerCountdown: number;
    chatbotTimerEndMessage: string;
    chatbotTimerMessageBeforeEnd: number;
    onChange: (params: onChangeParams) => void;
}

const ChatBotTimer = ({
    isChatbotTimer,
    chatbotTimerCountdown,
    chatbotTimerEndMessage,
    chatbotTimerMessageBeforeEnd,
    onChange,
}: Props) => {
    const { t } = useTranslation(namespace);

    const customInputStyle = {
        sx: {
            ".MuiOutlinedInput-notchedOutline": {
                border: "0",
                backgroundColor: 'rgb(245, 246, 250)',
            },
            "&.Mui-focused": {
                ".MuiOutlinedInput-notchedOutline": {
                    border: "0",
                },
            },
            "&: hover": {
                ".MuiOutlinedInput-notchedOutline": {
                    border: "0",
                },
            },
            ".MuiOutlinedInput-input": {
                ...modalTextStyle,
                zIndex: 3,
                lineHeight: '19px',
            },
            height: '40px',
            width: '100%',
            margin: '0px 0px 8px 0px',
        }
    };
    return (
        <Stack sx={{ fontSize: '13px' }}>
            <span style={{ fontSize: '15px', marginBottom: '20px' }}>{t('chatbot.settings.chatbotTimerTitle')}</span>
            <RowStack sx={{ marginBottom: '20px' }}>
                <span>{t('chatbot.settings.chatbotTimerPrefix')}</span>
                <BTInputField
                    className={classes.mui_number_field}
                    value={chatbotTimerCountdown ?? 30}
                    type="number"
                    onChange={({ target }: any) => onChange({ type: 'chatbotTimerCountdown', value: target.value })}
                    sx={{
                        ...customInputStyle.sx,
                        height: '30px',
                        width: '40px',
                        margin: '0px 10px',
                        padding: '0px',

                        ".MuiOutlinedInput-notchedOutline": {
                            border: "0px",
                            backgroundColor: 'rgb(245, 246, 250)',
                            padding: '0px'
                        },
                        ".MuiOutlinedInput-input": {
                            ...modalTextStyle,
                            zIndex: 3,
                            lineHeight: '19px',
                            padding: '0px',
                            textAlign: 'center',
                        },
                        "&.Mui-focused": {
                            ".MuiOutlinedInput-notchedOutline": {
                                border: "0",
                                borderBottom: '3px solid #ff9100',
                            },
                            "&: hover": {
                                ".MuiOutlinedInput-notchedOutline": {
                                    borderBottom: '3px solid #ff9100',
                                },
                            },
                        },
                    }}
                />

                <span>{t('chatbot.settings.chatbotTimerSuffix')}</span>
            </RowStack>
            {
                chatbotTimerCountdown <= 1 &&
                <span style={{ fontSize: '10px', fontWeight: '600', color: 'red' }}>
                    {t('chatbot.settings.chatbotTimerInvalidCountdown')}
                </span>
            }
            {!(chatbotTimerCountdown <= 1) &&
                chatbotTimerCountdown > 1440 &&
                <span style={{ fontSize: '10px', fontWeight: '600', color: 'red' }}>{t('chatbot.settings.chatbotTimerMaxCountdown')}</span>
            }

            <RowStack sx={{ marginBottom: '15px' }}>
                <Checkbox
                    checkedIcon={<CheckBoxIcon />}
                    sx={{
                        '& .MuiSvgIcon-root': {
                            color: 'rgb(35, 164, 85)',
                            marginRight: '10px',
                            fontSize: '1rem',
                        },
                        padding: '0px',
                    }}
                    checked={isChatbotTimer}
                    onChange={() => onChange({ type: 'isChatbotTimer' })}
                    disableRipple />
                <span>{t('chatbot.settings.enableExitNotification')}</span>
            </RowStack>

            {isChatbotTimer && (
                <Stack>

                    <RowStack sx={{ justifyContent: 'space-between' }}>
                        <span style={{ marginBottom: '10px' }}>{t('chatbot.settings.exitNotificationLabel')}</span>
                        <span style={{
                            fontSize: '10px',
                            fontWeight: chatbotTimerEndMessage.length > 1024 ? '700' : undefined,
                            color: chatbotTimerEndMessage.length > 1024 ? 'red' : undefined,
                        }}>
                            {chatbotTimerEndMessage.length}/1024
                        </span>
                    </RowStack>

                    <BTInputField
                        value={chatbotTimerEndMessage ?? ''}
                        type="text"
                        multiline={true}
                        rows={6}
                        onChange={({ target }: any) => onChange({ type: 'chatbotTimerEndMessage', value: target.value })}
                        sx={{ ...customInputStyle.sx, height: 'auto', marginBottom: '20px', p: '10px', }}
                    />
                    <RowStack sx={{ marginBottom: '20px' }}>
                        <span>{t('chatbot.settings.exitNotificationTimingPrefix')}</span>
                        <BTInputField
                            className={classes.mui_number_field}
                            value={chatbotTimerMessageBeforeEnd ?? 5}
                            type="number"
                            onChange={({ target }: any) => onChange({ type: 'chatbotTimerMessageBeforeEnd', value: target.value })}

                            sx={{
                                ...customInputStyle.sx,
                                height: '30px',
                                width: '40px',
                                margin: '0px 10px',
                                padding: '0px',

                                ".MuiOutlinedInput-notchedOutline": {
                                    border: "0px",
                                    backgroundColor: 'rgb(245, 246, 250)',
                                    padding: '0px'
                                },
                                ".MuiOutlinedInput-input": {
                                    ...modalTextStyle,
                                    zIndex: 3,
                                    lineHeight: '19px',
                                    padding: '0px',
                                    textAlign: 'center',
                                },
                                "&.Mui-focused": {
                                    ".MuiOutlinedInput-notchedOutline": {
                                        border: "0",
                                        borderBottom: '3px solid #ff9100',
                                    },
                                    "&: hover": {
                                        ".MuiOutlinedInput-notchedOutline": {
                                            borderBottom: '3px solid #ff9100',
                                        },
                                    },
                                },
                            }}
                        />
                        <span>{t('chatbot.settings.exitNotificationTimingSuffix')}</span>
                    </RowStack>
                    {
                        chatbotTimerMessageBeforeEnd <= 0 &&
                        <span style={{ fontSize: '10px', fontWeight: '600', color: 'red' }}>
                            {t('chatbot.settings.exitNotificationInvalidValue')}
                        </span>
                    }
                    {
                        !(chatbotTimerMessageBeforeEnd <= 0) &&
                        chatbotTimerMessageBeforeEnd >= chatbotTimerCountdown &&
                        <span style={{ fontSize: '10px', fontWeight: '600', color: 'red' }}>
                            {t('chatbot.settings.exitNotificationMustBeLess')}
                        </span>
                    }
                </Stack>
            )}
        </Stack>
    )
}

export default ChatBotTimer;
